interface ImageWithVariantLinks {
  src?: string;
  is_primary?: boolean;
  linked_variant_ids?: string[];
}

// A variant's image is whichever product image links to it, falling back to the product's
// primary (or first) image. Shared by every place that renders a variant thumbnail
// (cart, wishlist, upsell, discount-achiever) so the resolution rule only changes in one place.
export const getDefaultProductImage = (images: ImageWithVariantLinks[] = []): string | undefined =>
  images.find((image) => image?.is_primary)?.src ?? images[0]?.src;

export const getVariantImage = (
  images: ImageWithVariantLinks[] = [],
  variantId: string,
  defaultImage?: string,
): string | undefined =>
  images.find((image) => image?.linked_variant_ids?.includes(variantId))?.src ?? defaultImage;
